import { IconButton } from '@mui/material';
import { useDispatch } from 'react-redux';

import {
  Iconify,
  MenuPopover,
  RowActions as MenuRowActions,
  useMenuPopover,
} from '@app/components';
import { useDialog, useRequestState } from '@app/hooks';
import { Strings } from '@app/constants';
import { IAssets } from '../types';
import AddAssets from './add-assets';
import { DeleteDialog } from '@app/components/dialog';
import { selectDeleteAssetState } from '../selectors';
import { deleteAsset } from '../slice';
import { AddRepair } from './add-repair';

interface Props {
  row: IAssets;
}

const RowActions = ({ row }: Props) => {
  const menuPopover = useMenuPopover();
  const deleteDialog = useDialog();
  const assetsDialog = useDialog();
  const repairDialog = useDialog();

  const actions = [
    {
      label: Strings.rowActions.repair,
      callback: repairDialog.show,
    },
    { label: Strings.rowActions.edit, callback: assetsDialog.show },
    { label: Strings.rowActions.delete, callback: deleteDialog.show },
  ];
  const dispatch = useDispatch();
  const { loading } = useRequestState({
    stateSelector: selectDeleteAssetState,
    onSuccess: deleteDialog.hide,
    successMessageShown: true,
    errorShown: true,
  });

  const onPressDelete = () => {
    dispatch(
      deleteAsset({
        id: row?.id,
      })
    );
  };
  return (
    <>
      <IconButton onClick={menuPopover.show}>
        <Iconify icon="eva:more-vertical-fill" />
      </IconButton>

      <MenuPopover
        open={menuPopover.rowMenuAnchorElement}
        arrow="right-top"
        sx={{ width: 180 }}
        onClose={menuPopover.hide}
      >
        <MenuRowActions actions={actions} onClickAction={menuPopover.hide} />
      </MenuPopover>
      <DeleteDialog
        title={`${Strings.common.delete} ${Strings.sidebar.assets}`}
        deleteButtonTitle={Strings.button.confirm}
        caption={Strings.common.deleteCaption(Strings.sidebar.assets)}
        loading={loading}
        visible={deleteDialog.visible}
        onClickDelete={onPressDelete}
        onClose={deleteDialog.hide}
      />
      <AddAssets open={assetsDialog.visible} onClose={assetsDialog.hide} row={row} />
      {repairDialog.visible && <AddRepair open onClose={repairDialog.hide} row={row} />}
    </>
  );
};

export { RowActions };
